<template>
  <div id="app"
    :class="this.viewport.label">
    <transition name="loader">
      <global-loader v-show="loading" />
    </transition>
    <router-view />
  </div>
</template>

<script>
import GlobalLoader from '@/components/GlobalLoader'
import { mapGetters } from 'vuex'

export default {
  components: {
    GlobalLoader
  },
  computed: {
    ...mapGetters([
      'loading',
      'viewport'
    ])
  }
}
</script>

<style lang="scss">
@import "./assets/mixins/breakpoints";
@import "./assets/mixins/typo";
@import "./assets/mixins/cookiebot";
@import "./assets/fonts/fonts";

html {
  /*font-size: 62.5%;*/
  text-rendering: optimizeLegibility; -webkit-font-smoothing: antialiased;
}

body {
  margin: 0;
  background-color: black;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  letter-spacing: .07rem;
}

strong, h1, h2, h3, h4, h5{
  font-family: 'Sectra', sans-serif;
  font-weight: 400;
}

.loader-enter {
  opacity: 0;
}

.loader-enter-to {
  opacity: 1;
}

.loader-leave {
  opacity: 1;
}

.loader-leave-to {
  opacity: 0;
}

.loader-enter-active, .loader-leave-active {
  transition: opacity .5s;
}

* {
  position: relative;
  box-sizing: border-box;
}

ul, li, ol {
  list-style: none;
  list-style-type: none;
  padding: 0; margin: 0;
}

.default-container {
  width: 100%;
  padding: 0 3rem;
  box-sizing: border-box;
  margin: 0 auto;
  @media #{$medium_mq} {
    padding: 0 1.925rem;
  }
  @media #{$large_mq} {
    max-width: 900px;
  }
  @media #{$morelarge_mq} {
    max-width: 1040px;
  }
  @media #{$xlarge_mq} {
    max-width: 1260px;
  }
  @media #{$xxlarge_mq} {
    max-width: 1440px;
  }
}

.default-container.default-container--menu{
  @media #{$large_mq} {
    max-width: 980px;
  }
  @media #{$morelarge_mq} {
    max-width: 1100px;
  }
  @media #{$xlarge_mq} {
    max-width: 1340px;
  }
  @media #{$xxlarge_mq} {
    max-width: 1520px;
  }
  .menu-wrapper{
    @media #{$large_mq} {
      margin: 0 40px;
    }
  }
}

.default-container-smaller {
  width: 100%;
  padding: 0 1.925rem;
  box-sizing: border-box;
  margin: 0 auto;
  @media #{$large_mq} {
    max-width: 900px;
  }
  @media #{$xlarge_mq} {
    max-width: 1000px;
  }
  @media #{$xxlarge_mq} {
    max-width: 1120px;
  }
}

h1, h2, h3, h4, strong {
  font-weight: 400;
  font-style: normal;
}

.show-for-medium {
  display: none;
  @media #{$medium_mq} {
    display: block;
  }
}

.hide-for-medium {
  display: block;
  @media #{$medium_mq} {
    display: none;
  }
}

.show-for-large{
  display: none;
  @media #{$large_mq} {
    display: block;
  }
}

</style>
